<template>
  <v-container id="group-contacts" fluid tag="section">
    <v-overlay :value="isOverlayVisible">
      <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
    </v-overlay>
    <base-v-component
      :heading="` Patients`"
    />

    <template>
      <v-toolbar flat color="transparent">
        <v-text-field
          v-model="searchText"
          class="searchBox"
          label="Search patients"
          @keyup="_filterPatients"
        />

        <v-spacer />

        <ivr-call-initiator
          :patients="selected.length ? selected : filteredPatients"
          :templates="templates"
          :is-visible="ivrInitiator.isVisible"
          @on-send-start="messageSendInitiated"
          @dismiss="_hideComposerDialog"
          @on-success="callInitiated"
          @on-test-success="testMessageSent"
          @on-error="messageError"
        />
        <div class="button-separator" />

        <v-btn color="primary" v-show="selected.length" dark class="mb-2" @click="initiateCall">
          <v-icon small class="mr-2">
            mdi-phone
          </v-icon>
          <span>
            Initiate Call
          </span>
        </v-btn>
        <v-btn
          color="primary"
          v-show="!selected.length && filteredPatients.length"
          dark
          class="mb-2"
          @click="initiateCall"
        >
          <v-icon small class="mr-2">
            mdi-phone
          </v-icon>
          <span>
            Initiate mass call
          </span>
        </v-btn>

        <div class="button-separator" />

        <message-composer-dialog
          :patients="selected"
          :templates="templates"
          :is-visible="messageComposer.isVisible"
          @on-send-start="messageSendInitiated"
          @dismiss="_hideComposerDialog"
          @on-success="messageSent"
          @on-test-success="testMessageSent"
          @on-error="messageError"
        />
        <v-btn color="primary" v-show="selected.length" dark class="mb-2" @click="_composeMessage">
          <v-icon small class="mr-2">
            mdi-message
          </v-icon>
          <span>
            Compose message
          </span>
        </v-btn>
        <v-btn
          color="primary"
          v-show="!selected.length && filteredPatients.length"
          dark
          class="mb-2"
          @click="_composeMessage"
        >
          <v-icon small class="mr-2">
            mdi-message
          </v-icon>
          <span>
            Compose mass message
          </span>
        </v-btn>
        <div class="button-separator" />

        <email-composer-dialog
          :patients="selected"
          :templates="templates"
          :is-visible="emailComposer.isVisible"
          @dismiss="_hideComposerDialog"
          @on-send-start="messageSendInitiated"
          @on-success="messageSent"
          @on-test-success="testMessageSent"
          @on-error="messageError"
        />
        <v-btn color="primary" v-show="selected.length" dark class="mb-2" @click="_composeEmail">
          <v-icon small class="mr-2">
            mdi-email
          </v-icon>
          <span>
            Compose email
          </span>
        </v-btn>
        <v-btn
          color="primary"
          v-show="!selected.length && filteredPatients.length"
          dark
          class="mb-2"
          @click="_composeEmail"
        >
          <v-icon small class="mr-2">
            mdi-email
          </v-icon>
          <span>
            Compose mass email
          </span>
        </v-btn>
      </v-toolbar>
    </template>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredPatients"
      item-key="id"
      show-select
      sort-by="firstName"
      @toggle-select-all="selectAllToggle"
    >
      <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
        <v-simple-checkbox
          :value="isSelected"
          @input="select($event)"
          :readonly="!item.hasValidNumber"
          :disabled="!item.hasValidNumber"
        />
      </template>
      <template v-slot:[`item.first_name`]="{ item }">
        <span class="nameLink" @click="onPatientRowClick(item)">
          {{ item.first_name }}
        </span>
      </template>
            <template v-slot:[`item.first_name`]="{ item }">
        <span class="nameLink" @click="onPatientRowClick(item)">
          {{ item.first_name }}
        </span>
      </template>
            <template v-slot:[`item.provider`]="{ item }">
        <span class="nameLink" @click="onPatientRowClick(item)">
          {{ item.ProviderFirstName }} {{ item.ProviderLastName }}
        </span>
      </template>
            <template v-slot:[`item.apptDate`]="{ item }">
        <span class="nameLink" @click="onPatientRowClick(item)">
          {{ moment(item.ApptDate).format('MM/DD/YYYY hh:mm a') }}
        </span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span class="nameLink" @click="onPatientRowClick(item)">
          {{ item.ApptStatus }}
        </span>
      </template>
      <template v-slot:no-data>
        <p class="mb-4 mt-4">
          No Patients to display
        </p>
        <v-btn color="primary" outlined class="mb-4" @click="_initiateLoad">
          Refresh
        </v-btn>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="senderActions">
          <v-icon small @click="removeContact(item)">
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <div class="py-3" />
    <comm-validation-dialog
      :is-visible="commValidationPrompt.isVisible"
      :comm-mode="commValidationPrompt.commMode"
      :selected-patients="selected.length ? selected : filteredPatients"
      @confirm-selection="_updateSelctionAndShowComposer"
      @on-close="_hideCommValidationDialog"
    />
  </v-container>
</template>

<script>
  /* eslint-disable */
import moment from "moment";
import { ApiCalls } from "../../../../api-calls";
import Api from "../../../../modules/shared-module/api";
import EventEmitter from "../../../../utils/event-emitter";
import HelperMethods from "../../../../utils/helper-methods";
import UserHelper from "../../../../utils/user-helper";
import IvrCallInitiator from "../../components/ivr-call-initiator/ivr-call-initiator.vue";

export default {
  components: {
    CommValidationDialog: () =>
      import("../../components/comm-validation-dialog/comm-validation-dialog.vue"),
    MessageComposerDialog: () => import("../../components/message-composer/message-composer"),
    EmailComposerDialog: () => import("../../components/email-composer/email-composer"),
    IvrCallInitiator,
  },
  props: {
    groupId: {
      required: true,
      type: Number
    }
  },
  data: () => ({
    dialog: false,
    moment,
    templates: [],
    headers: [
      { text: "First Name", value: "first_name" },
      { text: "Last Name", value: "last_name" },
      { text: "Phone", value: "phone" },
      { text: "Email", value: "email" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    snackbar: false,
    notification: "Unknown",
    selected: [],
    senders: [],
    searchText: "",
    filteredPatients: [],
    patients: [],
    groupDetails: {},
    isOverlayVisible: false,
    groups: [],
    messageComposer: {
      isVisible: false,
      isBulkMode: false
    },
    emailComposer: {
      isVisible: false,
      isBulkMode: false
    },
    commValidationPrompt: {
      isVisible: false,
      commMode: "sms"
    },
    ivrInitiator: {
      isVisible: false,
      isBulkMode: false
    },
  }),

  computed: {},

  watch: {
    dialog(val) {
      // eslint-disable-next-line no-unused-expressions
      val || this.close();
    }
  },

  async created() {
    this.usremail = localStorage.getItem("username");
    this.billPayUserId = localStorage.getItem("billpayUserId");
    this._initiateLoad();
  },

  methods: {
    onPatientRowClick(row) {
      console.log("row :>> ", row);
      EventEmitter.dispatch("show-patient-details", {
        ContactID: row.id,
        CellNumber: row.phone,
        MedicalGroupID: row._original.MedicalGroupID
      });
    },
    async _initiateLoad() {
      await HelperMethods.sleepTime(400);
      await this._loadPatients();
      this._loadGroupDetails();
      this._loadTemplates();
    },
    async _loadGroupDetails() {
      try {
        this.isOverlayVisible = true;
        const response = await ApiCalls.getGroupDetails(this.groupId);
        this.groupDetails = response.data ? response.data : {};
        // eslint-disable-next-line no-empty
      } catch (error) {
        this.groupDetails = {};
      }
      this.isOverlayVisible = false;
    },
    async _loadPatients() {
      try {
        this.isOverlayVisible = true;
        let activePracticeId = null;
        if (this.$store.state.posActivePractice && this.$store.state.posActivePractice.value) {
          activePracticeId = this.$store.state.posActivePractice.value;
        }
        let response = [];
        if (activePracticeId) {
          response = await Api.staticGroupApi.private.fetchGroupPatientsWithPracticeId(this.groupId, activePracticeId);
        } else {
          response = await Api.staticGroupApi.private.fetchGroupPatients(this.groupId);
        }
        const patients = response && response.data && response.data.length ? response.data : [];
        this.patients = patients.map(p => ({
          first_name: p.FirstName,
          last_name: p.LastName,
          phone: p.CellNumber,
          id: p.GuarantorID,
          email: p.Email,
          _original: p,
        }));
        await this._sanitizePatients();
        this._filterPatients();
      } catch (error) {
        console.log("error 3 :>> ", error);
        this.patients = [];
        this.notification = "Unable to load patients";
        this.snackbar = true;
      }
      this.isOverlayVisible = false;
    },

    async _sanitizePatients() {
      // Loop through all patients
      // Add the 'hasValidNumber' flag based on number availability
      // Also get the numbers to check
      const formattedPatients = this.patients.map(p => {
        if (p.phone && p.phone.length) {
          p.hasValidNumber = true;
          p.phone = this._prependAreaCodeIfRequired(p.phone);
        }
        return p;
      });
      this.patients = formattedPatients;
    },

    _prependAreaCodeIfRequired(phoneNumber) {
      if (phoneNumber && phoneNumber.length) {
        if (phoneNumber.indexOf("+1") === 0) {
          return phoneNumber;
        } else {
          return `+1${phoneNumber}`;
        }
      }
      return null;
    },

    async _loadTemplates() {
      try {
        const response = await ApiCalls.fetchTemplates();
        this.templates = response.data && response.data.length ? response.data : [];
      } catch (error) {
        this.templates = [];
      }
    },

    _filterPatients() {
      this.filteredPatients = [...this.patients];
      const searchText = this.searchText.trim().toLowerCase();
      if (searchText && searchText.length) {
        // eslint-disable-next-line array-callback-return
        this.filteredPatients = this.filteredPatients.filter(c => {
          if (
            c.first_name &&
            c.first_name.length &&
            c.first_name.toLowerCase().indexOf(searchText) > -1
          ) {
            return true;
          }
          if (
            c.last_name &&
            c.last_name.length &&
            c.last_name.toLowerCase().indexOf(searchText) > -1
          ) {
            return true;
          }
          if (c.phone && c.phone.length && c.phone.toLowerCase().indexOf(searchText) > -1) {
            return true;
          }
          if (c.email && c.email.length && c.email.toLowerCase().indexOf(searchText) > -1) {
            return true;
          }
        });
      }
    },
    selectAllToggle() {
      if (this.selected.length < this.filteredPatients.length) {
        // Currently selectable rows count is greater than selected rows
        // So select all
        this.selected = [];
        const self = this;
        this.filteredPatients.forEach(item => {
          self.selected.push(item);
        });
      } else {
        // Currently selectable rows count is equal to selected rows
        // So de-select all
        this.selected = [];
      }
    },
    messageSendInitiated() {
      this.isOverlayVisible = true;
    },
    messageSent() {
      this.isOverlayVisible = false;
      this.notification = "Message has been sent";
      this.snackbar = true;
    },
    callInitiated() {
      this.isOverlayVisible = false;
      this.notification = "Call has been initiated";
      this.snackbar = true;
    },
    testMessageSent() {
      this.isOverlayVisible = false;
      this.notification = "Test message has been sent";
      this.snackbar = true;
    },

    showOverlay() {
      this.isOverlayVisible = true;
    },
    hideOverlay() {
      this.isOverlayVisible = false;
    },
    onPatientAddedToGroups() {
      this.notification = "Successfully added to groups";
      this.snackbar = true;
    },

    messageError(error) {
      let errorMessage = "";
      if (error && error.response && error.response.data && error.response.data.length) {
        errorMessage = error.response.data;
      } else {
        errorMessage = "Unable to send the message";
      }
      this.notification = errorMessage;
      this.isOverlayVisible = false;
      this.snackbar = true;
      throw error;
    },

    async removeContact(contact) {
      if (
        window.confirm(
          `Are you sure you want to remove ${contact.first_name} ${contact.last_name} from the group?`
        )
      ) {
        try {
          await ApiCalls.removePatientFromGroup(this.groupId, contact.id);
          this.notification = "Removed Contact";
          this.snackbar = true;
          await this._loadPatients();
        } catch (error) {
          this.notification = "Unable to remove contact";
          this.snackbar = true;
        }
      }
    },
    _composeMessage() {
      this.commValidationPrompt = {
        isVisible: true,
        commMode: "sms"
      };
    },
    _composeEmail() {
      this.commValidationPrompt = {
        isVisible: true,
        commMode: "email"
      };
    },
    _hideCommValidationDialog() {
      this.commValidationPrompt.isVisible = false;
    },
    _updateSelctionAndShowComposer(updatedPatiens) {
      this.selected = updatedPatiens;
      if (this.commValidationPrompt.commMode === "sms") {
        this.messageComposer = {
          isVisible: true,
          isBulkMode: false
        };
      } else {
        // Email
        this.emailComposer = {
          isVisible: true,
          isBulkMode: false
        };
      }
      this._hideCommValidationDialog();
    },
    _hideComposerDialog() {
      this.messageComposer = {
        isVisible: false,
        isBulkMode: false
      };
      this.emailComposer = {
        isVisible: false,
        isBulkMode: false
      };
      this.ivrInitiator = {
        isVisible: false,
        isBulkMode: false
      };
    },
    initiateCall() {
      this.ivrInitiator = {
        isVisible: true,
        isBulkMode: false
      };
    },
    _onPatientAddSuccess() {
      this._hideAddPatientsDialog();
      this._loadPatients();
    },

  }
};
</script>

<style scoped>
.spinner {
  margin-left: 17rem;
}
.v-overlay.v-overlay--active.theme--dark {
  z-index: 300 !important;
}
@media only screen and (max-width: 968px) {
  .spinner {
    margin-left: 0;
  }
}
.searchBox {
  margin-left: 15px;
}
</style>

<style lang="scss">
.v-data-table-header tr th {
  padding: 0 16px !important;
}
.button-separator {
  margin: 0 15px;
}
.nameLink {
  text-decoration: underline;
  color: rgb(0, 161, 73);
  font-weight: 600;
  cursor: pointer;
}
</style>
